module.exports = __webpack_public_path__ + "static/assets/f8d6d074eb4dcbdc95cf9344779f2bf5.png";